module.exports = __webpack_public_path__ + "static/media/dots5.69b3c3a4.png";